function Impact() {
  return (
    <div className="w-full mb-16 font-DM" id="Impact">
      <h1 className="font-DM text-pinkie uppercase mb-6">Impact</h1>
      <div className="grid grid-cols-2 gap-x-10">
        <img
          src="https://res.cloudinary.com/de9qkjreb/image/upload/v1789245077/kaya_validation_vpc3b3.png"
          alt="In-field testing"
          className="w-full col-span-1 rounded "
        ></img>
        <div className="col-span-1">
          <h1 className="font-DM opacity-60 uppercase mb-4">User Value</h1>
          <p className="mb-8">
            Centralizes climbing knowledge, in turn facilitating project return.
          </p>
          <h1 className="font-DM opacity-60 uppercase mb-4">business value </h1>
          <p>
            Extends user life cycle, keeping climbers active in app beyond
            discovery.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Impact;
